var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,30h-5C0.5,30,0,29.5,0,28.9V19c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v9.9C7.3,29.5,6.8,30,6.1,30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,30h-5c-0.6,0-1.1-0.5-1.1-1.1V2c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v26.9C18.6,29.5,18.1,30,17.5,30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,30h-5c-0.6,0-1.1-0.5-1.1-1.1V11.5c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v17.3C30,29.5,29.5,30,28.9,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBar);
export default __webpack_public_path__ + "static/media/icon-bar.f6dbd9f4bf6652e72fb7ba266bfcbc55.svg";
export { ForwardRef as ReactComponent };